var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"0":1,"445":1,"510":1,"657":1,"881":1,"1075":1,"1106":1,"1178":1,"1533":1,"1686":1,"1703":1,"1713":1,"1833":1,"2386":1,"2388":1,"2557":1,"2642":1,"2803":1,"2815":1,"2838":1,"2911":1,"3411":1,"3810":1,"3831":1,"3843":1,"3906":1,"4014":1,"4018":1,"4029":1,"4042":1,"4164":1,"4299":1,"4390":1,"4631":1,"4727":1,"4783":1,"4793":1,"4892":1,"4960":1,"5120":1,"5161":1,"5218":1,"5264":1,"5607":1,"5686":1,"5871":1,"6087":1,"6246":1,"6354":1,"6386":1,"6470":1,"6633":1,"6662":1,"6703":1,"6745":1,"6798":1,"6870":1,"7056":1,"7223":1,"7241":1,"7316":1,"7409":1,"7441":1,"7592":1,"7755":1,"7885":1,"8159":1,"8196":1,"8368":1,"8380":1,"8389":1,"8487":1,"8501":1,"8712":1,"8786":1,"8900":1,"9515":1,"9626":1,"9676":1,"9744":1,"9831":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr